import { render, staticRenderFns } from "./BaseFileView.vue?vue&type=template&id=37199d04&scoped=true&"
import script from "./BaseFileView.vue?vue&type=script&lang=js&"
export * from "./BaseFileView.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileView.vue?vue&type=style&index=0&id=37199d04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37199d04",
  null
  
)

export default component.exports